<template>
  <ModalAddBranch
    ref="modal"
    v-if="modalShowAddBranch"
    @closeModal="modalCloseAddBranch"
    @openAlertSuccess_BranchCreated="openAlert_BranchCreated"
    @openAlertSuccess_BranchUpdated="openAlert_BranchUpdated"
    :branchData="branchToEdit"
  />
  <transition name="fade">
    <AlertConfirmation
      v-if="alert_confirmation"
      @confirmNo="handle_clicked_no"
      @confirmYes="handle_clicked_yes"
      :animation_class="animation_alert_confirmation_class"
      text="Are you sure you want to delete this Branch?"
      title="Delete Branch"
      text_class="text-xl font-medium"
    />
  </transition>
  <section class="grid grid-cols-2 lg:grid-cols-4 gap-4 pb-96 h-fit">
    <PageHeader
      class="col-span-1 lg:col-span-2"
      title="Branches"
      subtitle="Our Latest Branches"
    ></PageHeader>
    <div class="col-span-1 lg:col-span-2 flex justify-end items-end">
      <Button
        button_id="new-branch"
        button_text="&#43; New Branch"
        @click="showModalAddBranch()"
      />
    </div>
    <Card card_class="col-span-2 lg:col-span-4">

      <AlertSuccess v-if="alert_success" :text="alert_text" />

      <DinamicTable :header_columns="table_header_branches">
        <TableRow v-if="allBranches.length <= 0">
          <td colspan="6" class="p-3 text-center italic text-white tracking-widest">
            ~ Belum ada data ~
          </td>
        </TableRow>
        <TableRow v-for="(branch, index) in filteredBranch" :key="branch.id">
          <TableCell>{{ index + 1 }}</TableCell>
          <TableCell>{{ branch.name }}</TableCell>
          <TableCell>{{ branch.location }}</TableCell>
          <TableCell>{{ branch.address }}</TableCell>
          <TableCell>{{ branch.phone }}</TableCell>
          <TableCell>
            <div class="flex items-center gap-2">
              <!-- <TableButtonView
                :path="#"
                :container_id="`btnViewBranch${branch.id}`"
              /> -->
              <TableButtonEdit
                path="#"
                :container_id="`btnEditBranch${branch.id}`"
                @click="editBranch(branch)"
              />
              <TableButtonDelete
                @click="deleteBranch(branch.id)"
                path="#"
                :container_id="`btnDeleteBranch${branch.id}`"
              />
            </div>
          </TableCell>
        </TableRow>
      </DinamicTable>
    </Card>
  </section>
</template>

<script>
import PageHeader from "@/components/molecules/PageHeader.vue";
import DinamicTable from "@/components/organisms/DinamicTable.vue";
import { mapActions, mapGetters } from "vuex";
import { formatRupiah, formatDate } from "@/helpers/formating";
import Card from "@/components/organisms/Card.vue";
import TableCell from "@/components/atoms/table/TableCell.vue";
import TableRow from "@/components/atoms/table/TableRow.vue";
import TableButtonView from "@/components/atoms/table/TableButtonView.vue";
import TableButtonEdit from "@/components/atoms/table/TableButtonEdit.vue";
import TableButtonDelete from "@/components/atoms/table/TableButtonDelete.vue";
import AlertConfirmation from "@/components/alerts/AlertConfirmation.vue";
import AlertSuccess from "@/components/alerts/AlertSuccess.vue";
import Button from "@/components/buttons/Button.vue";
import ButtonRouter from "@/components/buttons/ButtonRouter.vue";
import ModalAddBranch from "@/components/modals/ModalAddEditBranch.vue";

export default {
  created() {
    this.$store.dispatch("branches/fetchBranches");
  },
  components: {
    PageHeader,
    DinamicTable,
    Card,
    TableCell,
    TableRow,
    TableButtonView,
    TableButtonEdit,
    TableButtonDelete,
    AlertConfirmation,
    Button,
    ButtonRouter,
    ModalAddBranch,
    AlertSuccess,
  },
  methods: {
    formatDate,
    formatRupiah,
    deleteTransaction() {
      this.isBlur = true;
      this.showAlertConfirmation();
    },
    showAlertConfirmation() {
      this.alert_confirmation = true;
    },
    handle_clicked_no() {
      this.isBlur = false;
      this.alert_confirmation = false;
      this.animation_alert_confirmation_class = "animate__backOutUp";
      this.branchIdToDelete = null;
    },
    handle_clicked_yes() {
      this.isBlur = false;
      this.alert_confirmation = false;
      this.animation_alert_confirmation_class = "animate__backOutUp";
      this.$store.dispatch("branches/deleteBranchById", this.branchIdToDelete);
      this.branchIdToDelete = null;
    },
    showModalAddBranch() {
      this.branchToEdit = null;
      this.branchIdToDelete = null;
      this.modalShowAddBranch = true;
    },
    modalCloseAddBranch() {
      this.modalShowAddBranch = false;
      this.$store.dispatch("branches/fetchBranches");
    },
    openAlert_BranchCreated() {
      this.alert_success = true;
      this.alert_text = 'Branch added successfully!';

      setTimeout(() => {
        this.alert_success = false;
        this.alert_text = 'Branch added successfully!';
      }, 1500);
    },
    openAlert_BranchUpdated() {
      this.alert_success = true;
      this.alert_text = 'Branch updated successfully!';

      setTimeout(() => {
        this.alert_success = false;
        this.alert_text = 'Branch updated successfully!';
      }, 1500);
    },
    deleteBranch(id) {
      this.branchIdToDelete = id;
      this.showAlertConfirmation();
      
      setTimeout(() => {
        this.alert_success = false;
        this.alert_text = 'Branch updated successfully!';
      }, 1500);
    },
    editBranch(branch) {
      this.branchToEdit = branch;
      this.modalShowAddBranch = true;
    },
  },
  computed: {
    ...mapGetters("branches", ["allBranches"]),
    ...mapActions("branches", ["fetchBranches"]),
    filteredBranch() {
      return this.allBranches;
    },
  },
  data() {
    return {
      table_header_branches: [
        "No",
        "Name",
        "Location",
        "Address",
        "Phone",
        "Action",
      ],

      alert_success: false,
      alert_text: '',
      alert_confirmation: false,
      animation_alert_confirmation_class: "",

      modalShowAddBranch: false,

      branchIdToDelete: null,
      branchToEdit: null,
    };
  },
};
</script>
